import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import './index.css';

// Components
import Login from './Login';
import Dashboard from './Dashboard';
import RegisterAndAcceptInvitation from './RegisterAndAcceptInvitation';
import AcceptOrganizationInvitation from './AcceptOrganizationInvitation';

// Context Providers
import { AuthProvider, ProtectedRoute } from './contexts/AuthContext';
import { AppStateProvider } from './contexts/AppStateContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public route */}
          <Route path="/login" element={<Login />} />
          <Route path="/invitation-register" element={<RegisterAndAcceptInvitation />} />

          {/* Protected routes */}
          <Route path="/accept-invitation" element={
            <ProtectedRoute element={<AppStateProvider><AcceptOrganizationInvitation /></AppStateProvider>} />
          } />

          <Route path="/" element={
            <ProtectedRoute element={<AppStateProvider><Dashboard /> </AppStateProvider>} />
          } />
          <Route path="/:tab" element={
            <ProtectedRoute element={<AppStateProvider><Dashboard /> </AppStateProvider>} />
          } />

          {/* Redirect to home if no route matches */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
